/**
 * Project: fuse-react-app
 * FilePath: /src/client/app/store/reducers/index.js
 * File: index.js
 * Created Date: Monday, January 21st 2019, 1:54:22 pm
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Mon Feb 25 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

import { combineReducers } from 'redux'
import appReducer from './app.reducer'
import activeSectors from './activeSectors.reducer'

const reducers = combineReducers({
  app: appReducer,
  activity: activeSectors
})

export default reducers
